









































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {MixinMember} from '@/components/mixins/MixinMember'
import DeliveryRequest from '@/model/request/DeliveryRequest'
import {IResource, ObjectCollection, WholeCollection} from 'simpli-web-sdk'
import {ItrackCollection} from '@/helpers'
import Motorista from '@/model/resource/Motorista'
import DeliveryDriverRequest from '@/model/request/DeliveryDriverRequest'

@Component
export default class FilterDeliveryDriver extends Mixins(MixinMember) {
  @Prop({type: Object, required: true}) value!: DeliveryDriverRequest

  allMotorista = ItrackCollection.allMotoristaFiltro

  async mounted() {
    await this.allMotorista.query()
    await this.value.allCentroDeCusto.query()
    await this.value.allTipoInsumo.query()
  }

  get motoristaResource() {
    return this.allMotorista.get(this.value.idMotorista)
  }

  set motoristaResource(val: Motorista | null) {
    this.value.idMotorista = val && val.$id || null
  }

  get valueComputed() {
    return this.value
  }

  set valueComputed(val) {
    this.$emit('input', val)
  }

  formatSigla() {
    if (this.value.sigla) {
      this.value.sigla = this.value.sigla.toUpperCase()
    }
  }
}
